// Not foolproof, should handle escape characters
export function markdownToPlainText(markdown: string): string {
  if (!markdown) return ''

  let text = markdown

  // Replace horizontal rules
  text = text.replace(/^\s*[-*_]{3,}\s*$/gm, '\n\n---\n\n')

  // Handle code blocks
  text = text.replace(/```[\s\S]*?```/g, (match) => {
    return match
      .replace(/```(?:\w+)?\n/, '') // Remove opening ```lang
      .replace(/\n```/, '') // Remove closing ```
  })

  // Handle inline code
  text = text.replace(/`([^`]+)`/g, '$1')

  // Handle headers
  text = text.replace(/^#{1,6}\s+(.+)$/gm, (_, header) => {
    return header + '\n'
  })

  // Handle blockquotes
  text = text.replace(/^>\s+(.+)$/gm, (_, quote) => {
    return quote + '\n'
  })

  // Handle bold and italic
  text = text.replace(/\*\*([^*]+)\*\*/g, '$1') // Bold **text**
  text = text.replace(/__([^_]+)__/g, '$1') // Bold __text__
  text = text.replace(/\*([^*]+)\*/g, '$1') // Italic *text*
  text = text.replace(/_([^_]+)_/g, '$1') // Italic _text_

  // Handle strikethrough
  text = text.replace(/~~([^~]+)~~/g, '$1')

  // Handle ordered lists
  text = text.replace(/^\s*\d+\.\s+(.+)$/gm, (_, item) => {
    return '• ' + item + '\n'
  })

  // Handle unordered lists
  text = text.replace(/^\s*[-*+]\s+(.+)$/gm, (_, item) => {
    return '• ' + item + '\n'
  })

  // Handle links [text](url) -> text
  text = text.replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')

  // Handle reference links [text][ref] -> text
  text = text.replace(/\[([^\]]+)\]\[[^\]]*\]/g, '$1')

  // Remove reference link definitions
  text = text.replace(/^\s*\[[^\]]+\]:\s*[^\s]+.*$/gm, '')

  // Handle images ![alt](url) -> [Image: alt]
  text = text.replace(/!\[([^\]]+)\]\([^)]+\)/g, '[Image: $1]')

  // Handle HTML tags
  text = text.replace(/<[^>]+>/g, '')

  // Fix multiple newlines (more than 2)
  text = text.replace(/\n{3,}/g, '\n\n')

  // Fix hashtags \#
  text = text.replace(/\\#/g, '#')

  return text.replace(/\s+/g, ' ').trim()
}

interface Heading {
  id: string
  text: string
}

export function parseHeading(markdown: string): Heading[] {
  const lines = markdown.split('\n')
  const headings: Heading[] = []
  let id = 1

  for (const line of lines) {
    const match = line.match(/^#\s+(.*)/) // Only match H1
    if (match && match[1]) {
      headings.push({
        id: String(id++),
        text: match[1].trim(),
      })
    }
  }

  return headings
}
